<template>
  <article class="search">
    <div class="search__container">
      <div class="search__top">
        <form class="search__form" onsubmit="event.preventDefault();" spellcheck="false">
          <input class="search__input" :placeholder=title  type="search" v-model="question" autofocus>
          <button class="search__cancel default-btn default-btn--dark" data-search-close type="button">
            <span class="default-btn__text">{{ cancelTitle }}</span>
            <svg class="default-btn__icon" aria-hidden="true">
              <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-close"></use>
            </svg>
          </button>
        </form>
        <div class="search__loader loader" v-if="isLoader">
          <span class="loader__point"></span>
          <span class="loader__point"></span>
          <span class="loader__point"></span>
        </div>
      </div>
      <div class="search__bottom">
        <div class="search-result">
          <div class="search-result__content">
            <div class="search-result__section" v-if="result.solutions">
              <div class="search-result__top">
                <h4 class="search-result__title">{{ solutionsTitle }}</h4>
                <span class="search-result__value">{{result.COUNT.SOLUTIONS}}</span>
              </div>
              <div class="search-result__items">
                <div class="search-result__item" v-for="(item, key) in result.solutions" :key="item.ID" :number="key">
                  <div class="search-product">
                    <div class="search-product__cont">
                      <div class="search-product__img">
                        <picture v-if="item.PICTURE">
                          <source :srcset="item.PICTURE_WEBP ?? ''" type="image/webp">
                          <img :src="item.PICTURE ?? ''" :alt="item.NAME" loading="lazy">
                        </picture>

                        <img v-else src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
                      </div>
                      <div class="search-product__desc">
                        <a class="search-product__name" :href="item.URL">{{item.NAME}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="search-result__section" v-if="result.stock">
              <div class="search-result__top">
                <h4 class="search-result__title">{{ stockTitle }}</h4>
                <span class="search-result__value">{{result.COUNT.STOCK}}</span>
              </div>
              <div class="search-result__items">
                <div class="search-result__item" v-for="(item, key) in result.stock" :key="item.ID" :number="key">
                  <div class="search-product">
                    <div class="search-product__cont">
                      <div class="search-product__img">
                        <picture v-if="item.PICTURE">
                          <source :srcset="item.PICTURE_WEBP ?? ''" type="image/webp">
                          <img :src="item.PICTURE ?? ''" :alt="item.NAME" loading="lazy">
                        </picture>

                        <img v-else src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
                      </div>
                      <div class="search-product__desc">
                        <a class="search-product__name">{{item.NAME}}</a>
                        <div class="search-product__info">{{item.SIZE}}</div>
                      </div>
                    </div>

                    <add-to-cart-search
                        :product-id='Number(item.ID)'
                        :min-quantity='Number(item.PROPERTY_AMOUNT_VALUE)'
                        :max-quantity='Number(item.CATALOG_QUANTITY)'
                        :step-quantity=5
                        :params='formatParams(item.PROPERTY_LENGTH_FROM_VALUE, item.PROPERTY_HEIGHT_FROM_VALUE, item.PROPERTY_WIDTH_FROM_VALUE)'
                    ></add-to-cart-search>
                  </div>
                </div>
              </div>
            </div>
            <div class="search-result__section" v-if="result.other">
              <div class="search-result__top">
                <h4 class="search-result__title">{{ otherTitle }}</h4><span
                  class="search-result__value">{{result.COUNT.OTHER}}</span>
              </div>
              <div class="search-result__items">
                <div class="search-result__item" v-for="(item, key) in result.other" :key="item.ID" :number="key">
                  <span class="search-result__item-label">{{item.NAME}}</span>
                  <div class="search-result__item-text">
                    <a class="link link--white-reverse" :href="item.URL" v-html="item.DESCRIPTION"></a>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-result__section" v-if="errors[0]">{{ errors[0] }}</div>
            <div v-if="isEmpty">{{ emptyTitle }}</div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
// import {mapState} from 'vuex'
import AddToCartSearch from "@/components/cart/AddToCartSearch.vue";

export default {
  name: "SearchHeader",
  props: {
    title: {
      type: [String],
      default: BX.message('SEARCH_TITLE')
    },
    cancelTitle: {
      type: [String],
      default: BX.message('SEARCH_CANCEL')
    },
    otherTitle: {
      type: [String],
      default: BX.message('SEARCH_OTHER')
    },
    emptyTitle: {
      type: [String],
      default: BX.message('SEARCH_EMPTY')
    },
    solutionsTitle: {
      type: [String],
      default: BX.message('CATALOG_SOLUTIONS')
    },
    stockTitle: {
      type: [String],
      default: BX.message('CATALOG_STOCK')
    },
  },
  components: {AddToCartSearch},
  data() {
    return {
      result: {},
      errors: {},
      success: false,
      question: '',
      isLoader: false,
      isEmpty: false,
    }
  },
  watch: {
    question: function () {
      this.isLoader = true
      this.isEmpty = false
      this.errors = {}
      this.debouncedGetAnswer()
    }
  },
  methods: {
    getAnswer: function () {
      let vm = this
      let formData = new FormData
      formData.append('question', this.question);
      this.$axios.post(
          '/api/search/get/',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      )
          .then(function (response) {
            vm.isLoader = false

            if ('data' in response.data) {
              vm.success = true
              vm.errors = {}
              vm.isEmpty = response.data.data.length === 0
              vm.result = response.data.data
            } else {
              let message = JSON.parse(response.data.message)
              vm.errors = message.errors
              vm.isEmpty = true
              vm.result = {}
            }
          })
          .catch(function (error) {
            console.log(error);
          })
    },
    formatParams(length, height, width) {
      return {
        'length': length,
        'height': height,
        'width': width,
      };
    },
  },
  created() {
    this.debouncedGetAnswer = this.$lodash.debounce(this.getAnswer, 1000)
  },
}
</script>